export default __webpack_public_path__ + "static/media/price_tag.37a7ccf2.svg";